<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <rect width="48" height="48" rx="8" fill="#363844" />
    <path
      d="M24.3815 40.9999C18.4226 41.0363 10.3459 33.2331 8.05357 28.1635L8.04584 28.1453L7.99946 28.0421C6.83705 25.3251 6.56654 23.0483 7.84489 20.0719C9.78174 15.5259 19.5773 4.96933 26.643 7.34323C31.693 9.04018 52.4311 21.4592 32.5293 37.1764C29.9911 39.1785 27.4143 40.9847 24.3815 40.9999ZM15.4532 26.8657C17.7502 30.8121 22.9208 35.4188 26.9769 32.8658C35.2653 27.6444 35.1509 22.6082 30.6975 18.2626C25.5239 13.2127 22.2793 14.0733 18.1536 18.2975C17.1767 19.2978 16.3528 19.955 15.3712 21.8189C14.6648 23.1683 14.5195 25.2644 15.4532 26.8657Z"
      fill="#53B7D1"
    />
  </svg>
</template>
